import { Box } from '@mui/material'
import { useSidebar } from 'contexts/sidebar'
import { useEffect, useRef } from 'react'
import SidebarDefault from './default'
import { useStyles } from './styles'
import SidebarSub from './sub-menu'

const Sidebar = () => {
  const { expandedSubMenu, onCloseAll } = useSidebar()

  const classes = useStyles()
  const sideBarReference = useRef<HTMLDivElement | null>(null)

  const handleClickOutside = (event: MouseEvent) => {
    if (sideBarReference.current && !sideBarReference.current.contains(event.target as Node)) {
      onCloseAll()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <aside ref={sideBarReference}>
      <SidebarDefault />
      {expandedSubMenu && <SidebarSub />}

      <Box className={classes.block} />
    </aside>
  )
}

export default Sidebar
